import * as Styled from './YoutubePosts.styled'

import { YoutubePostsProps } from './types'
import Analysis from '../../components/analysis'
import YoutubeCard from '../../components/youtube-card'

import { Row, Column } from '@zera-admin/page'
import { AnalysisData } from '../../components/analysis/types'
import { useEffect, useState } from 'react'
import UpdateButton from '../../components/update-button/UpdateButton'
import WidgetLayout from '../../widgets/widget-layout'
import { Post } from '../../widgets/types'
import { useFlagcardContext } from 'app/contexts/flagcard'
import { getAgendaReportYoutube } from 'services/http/report/agenda-report-4/endpoint'

const YoutubePosts: React.FC<YoutubePostsProps> = ({
  data,
  isEditValue,
  pageNumber,
  setIsEditValue,
  date,
  title,
  metaData,
}) => {
  const [postData, setPostData] = useState<Post | undefined>(data)
  const [videoId, setVideoId] = useState<string | undefined>('')
  const [pageData, setPageData] = useState<{
    title: string
    pageNumber: number
  }>({ title: title, pageNumber: pageNumber })

  const [editMode, setEditMode] = useState<boolean>(false)

  const [flagCard] = useFlagcardContext()

  useEffect(() => {
    if (isEditValue === pageNumber) {
      setEditMode(true)
    }
  }, [isEditValue, pageNumber])

  useEffect(() => {
    if (isEditValue === -1) {
      setPostData(data)
      setPageData({ title: title, pageNumber: pageNumber })
    }
  }, [isEditValue, data, title, pageNumber])

  const handleDeleteVideo = () => {
    setPostData(undefined)
  }

  const addVideo = () => {
    getAgendaReportYoutube({
      GroupId: metaData?.GroupId,
      VideoId: videoId,
    })
      .then((res) => {
        setPostData(res.data.data)
      })
      .catch((err) => {
        console.log(err)

        flagCard.add({
          appearance: 'error',
          title: 'Bir hata oluştu',
          children:
            'Veritabanında video bulunamadı. Lütfen video ID bilgisini kontrol ediniz.',
        })
      })
  }

  const onChange = (key: string, value: string) => {
    postData && setPostData({ ...postData, [key]: value })
  }

  const onChangePageData = (key: string, value: string) => {
    setPageData({
      ...pageData,
      [key]: value,
    })
  }

  const editProps = {
    isEditValue: isEditValue,
    setIsEditValue: setIsEditValue,
    pageNumber: pageData.pageNumber,
    metaData,
  }

  return (
    <WidgetLayout
      asideDate={date}
      asideTitle={pageData.title}
      pageNumber={pageData.pageNumber}
      onChange={onChangePageData}
      editMode={editMode}
    >
      <Styled.YoutubeAnalysisWrapper>
        <UpdateButton
          {...editProps}
          contentData={{
            Post: postData,
          }}
          title={pageData.title}
          editMode={editMode}
          setEditMode={setEditMode}
        />
        <Styled.YoutubeAnalysisContainer>
          <Row xs={{ justify: 'center' }}>
            {postData ? (
              <Column
                className="youtube"
                xs={{ size: postData?.Analysis ? 7 : 8 }}
              >
                <YoutubeCard
                  data={postData}
                  editMode={editMode}
                  onChange={onChange}
                />
                {editMode && (
                  <button
                    className="delete-youtube"
                    onClick={handleDeleteVideo}
                  >
                    X
                  </button>
                )}
              </Column>
            ) : (
              <Column xs={{ size: 8 }}>
                <div className="add-youtube">
                  <input
                    placeholder="Video ID"
                    value={videoId}
                    onChange={(e) => setVideoId(e.target.value)}
                  />
                  <button onClick={addVideo}>Video Ekle</button>
                </div>
              </Column>
            )}

            {postData?.Analysis && (
              <Column xs={{ size: 5 }}>
                <Analysis
                  editMode={editMode}
                  onChange={onChange}
                  data={postData as AnalysisData}
                />
              </Column>
            )}
          </Row>
        </Styled.YoutubeAnalysisContainer>
      </Styled.YoutubeAnalysisWrapper>
    </WidgetLayout>
  )
}

export default YoutubePosts
